
theme.helpers = {

    /*
        Checks whether something is mobile or not. 
        @return boolean
    */
    isMobile: function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },

    /*
        Gets parameters from a URL
        @return array
    */
    getAllUrlParams: function(url) {

        // get query string from url (optional) or window
        var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
      
        // we'll store the parameters here
        var obj = {};
      
        // if query string exists
        if (queryString) {
      
          // stuff after # is not part of query string, so get rid of it
          queryString = queryString.split('#')[0];
      
          // split our query string into its component parts
          var arr = queryString.split('&');
      
          for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');
      
            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
      
            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();
      
            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {
      
              // create key if it doesn't exist
              var key = paramName.replace(/\[(\d+)?\]/, '');
              if (!obj[key]) obj[key] = [];
      
              // if it's an indexed array e.g. colors[2]
              if (paramName.match(/\[\d+\]$/)) {
                // get the index value and add the entry at the appropriate position
                var index = /\[(\d+)\]/.exec(paramName)[1];
                obj[key][index] = paramValue;
              } else {
                // otherwise add the value to the end of the array
                obj[key].push(paramValue);
              }
            } else {
              // we're dealing with a string
              if (!obj[paramName]) {
                // if it doesn't exist, create property
                obj[paramName] = paramValue;
              } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                // if property does exist and it's a string, convert it to an array
                obj[paramName] = [obj[paramName]];
                obj[paramName].push(paramValue);
              } else {
                // otherwise add the property
                obj[paramName].push(paramValue);
              }
            }
          }
        }
      
        return obj;
        
    },

    /*
        Checks if an element is is the viewport
    */
    isElementInViewport: function() {
        
        // Special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );

    },
    /*
        Detects IE browsers
    */
    oldBrowsers: function() {
        
        // No javascript detection
        document.documentElement.classList.remove("no-js");

        // User agent string
        var ua = window.navigator.userAgent

        // Detection object
        var detection = {
            isIE11: (!!window.MSInputMethodContext && !!document.documentMode),
            isIE10Down: (ua.indexOf('MSIE') > 1) ? true : false
        }

        // Add a class for targeting for ie11
        if (detection.isIE11) {
            document.documentElement.classList.add("ie11");
        }

        return detection;

    }

}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

// ;(function() {
//   /* Built-in method references for those with the same name as other `lodash` methods. */
//   var nativeMax = Math.max;
//   var nativeMin = Math.min;
//   var reIsBinary = '/^0b[01]+$/i';
//   var now = Date.now;
  

//   /** Used to determine if values are of the language type `Object`. */
//   var objectTypes = {
//       'function': true,
//       'object': true
//   };

//   /** Detect free variable `exports`. */
//   var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
//     ? exports
//     : undefined;

//   /** Detect free variable `module`. */
//   var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
//     ? module
//     : undefined;

//   /** Detect the popular CommonJS extension `module.exports`. */
//   var moduleExports = (freeModule && freeModule.exports === freeExports)
//     ? freeExports
//     : undefined;

//   /** Detect free variable `global` from Node.js. */
//   var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

//   /** Detect free variable `self`. */
//   var freeSelf = checkGlobal(objectTypes[typeof self] && self);

//   /** Detect free variable `window`. */
//   var freeWindow = checkGlobal(objectTypes[typeof window] && window);

//   /** Detect `this` as the global object. */
//   var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

//   var root = freeGlobal ||
//   ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
//     freeSelf || thisGlobal || Function('return this')();

//   /**
  
//    * Creates a debounced function that delays invoking `func` until after `wait`
//    * milliseconds have elapsed since the last time the debounced function was
//    * invoked. The debounced function comes with a `cancel` method to cancel
//    * delayed `func` invocations and a `flush` method to immediately invoke them.
//    * Provide `options` to indicate whether `func` should be invoked on the
//    * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
//    * with the last arguments provided to the debounced function. Subsequent
//    * calls to the debounced function return the result of the last `func`
//    * invocation.
//    *
//    * **Note:** If `leading` and `trailing` options are `true`, `func` is
//    * invoked on the trailing edge of the timeout only if the debounced function
//    * is invoked more than once during the `wait` timeout.
//    *
//    * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
//    * until to the next tick, similar to `setTimeout` with a timeout of `0`.
//    *
//    * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
//    * for details over the differences between `debounce` and `throttle`.
//    *
//    * @since 0.1.0
//    * @category Function
//    * @param {Function} func The function to debounce.
//    * @param {number} [wait=0] The number of milliseconds to delay.
//    * @param {Object} [options={}] The options object.
//    * @param {boolean} [options.leading=false]
//    *  Specify invoking on the leading edge of the timeout.
//    * @param {number} [options.maxWait]
//    *  The maximum time `func` is allowed to be delayed before it's invoked.
//    * @param {boolean} [options.trailing=true]
//    *  Specify invoking on the trailing edge of the timeout.
//    * @returns {Function} Returns the new debounced function.
//    * @example
//    *
//    * // Avoid costly calculations while the window size is in flux.
//    * jQuery(window).on('resize', debounce(calculateLayout, 150));
//    *
//    * // Invoke `sendMail` when clicked, debouncing subsequent calls.
//    * jQuery(element).on('click', debounce(sendMail, 300, {
//    *   'leading': true,
//    *   'trailing': false
//    * }));
//    *
//    * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
//    * const debounced = debounce(batchLog, 250, { 'maxWait': 1000 });
//    * const source = new EventSource('/stream');
//    * jQuery(source).on('message', debounced);
//    *
//    * // Cancel the trailing debounced invocation.
//    * jQuery(window).on('popstate', debounced.cancel);
//    */
//   function debounce(func, wait, options) {
//       var lastArgs,
//           lastThis,
//           result,
//           timerId,
//           lastCallTime = 0,
//           lastInvokeTime = 0,
//           leading = false,
//           maxWait = false,
//           trailing = true;

//       if (typeof func != 'function') {
//           throw new TypeError('Expected a function');
//       }
//       wait = toNumber(wait) || 0;
//       if (isObject(options)) {
//           leading = !!options.leading;
//           maxWait = 'maxWait' in options && nativeMax(toNumber(options.maxWait) || 0, wait);
//           trailing = 'trailing' in options ? !!options.trailing : trailing;
//       }

//       function invokeFunc(time) {
//           var args = lastArgs,
//               thisArg = lastThis;

//           lastArgs = lastThis = undefined;
//           lastInvokeTime = time;
//           result = func.apply(thisArg, args);
//           return result;
//       }

//       function leadingEdge(time) {
//           // Reset any `maxWait` timer.
//           lastInvokeTime = time;
//           // Start the timer for the trailing edge.
//           timerId = setTimeout(timerExpired, wait);
//           // Invoke the leading edge.
//           return leading ? invokeFunc(time) : result;
//       }

//       function remainingWait(time) {
//           var timeSinceLastCall = time - lastCallTime,
//               timeSinceLastInvoke = time - lastInvokeTime,
//               result = wait - timeSinceLastCall;

//           return maxWait === false ? result : nativeMin(result, maxWait - timeSinceLastInvoke);
//       }

//       function shouldInvoke(time) {
//           var timeSinceLastCall = time - lastCallTime,
//               timeSinceLastInvoke = time - lastInvokeTime;

//           // Either this is the first call, activity has stopped and we're at the
//           // trailing edge, the system time has gone backwards and we're treating
//           // it as the trailing edge, or we've hit the `maxWait` limit.
//           return (!lastCallTime || (timeSinceLastCall >= wait) ||
//             (timeSinceLastCall < 0) || (maxWait !== false && timeSinceLastInvoke >= maxWait));
//       }

//       function timerExpired() {
//           var time = now();
//           if (shouldInvoke(time)) {
//               return trailingEdge(time);
//           }
//           // Restart the timer.
//           timerId = setTimeout(timerExpired, remainingWait(time));
//       }

//       function trailingEdge(time) {
//           clearTimeout(timerId);
//           timerId = undefined;

//           // Only invoke if we have `lastArgs` which means `func` has been
//           // debounced at least once.
//           if (trailing && lastArgs) {
//               return invokeFunc(time);
//           }
//           lastArgs = lastThis = undefined;
//           return result;
//       }

//       function cancel() {
//           if (timerId !== undefined) {
//               clearTimeout(timerId);
//           }
//           lastCallTime = lastInvokeTime = 0;
//           lastArgs = lastThis = timerId = undefined;
//       }

//       function flush() {
//           return timerId === undefined ? result : trailingEdge(now());
//       }

//       function debounced() {
//           var time = now(),
//               isInvoking = shouldInvoke(time);

//           lastArgs = arguments;
//           lastThis = this;
//           lastCallTime = time;

//           if (isInvoking) {
//               if (timerId === undefined) {
//                   return leadingEdge(lastCallTime);
//               }
//               // Handle invocations in a tight loop.
//               clearTimeout(timerId);
//               timerId = setTimeout(timerExpired, wait);
//               return invokeFunc(lastCallTime);
//           }
//           return result;
//       }
//       debounced.cancel = cancel;
//       debounced.flush = flush;
//       return debounced;
//   }

//   /**
//    * Creates a throttled function that only invokes `func` at most once per
//    * every `wait` milliseconds. The throttled function comes with a `cancel`
//    * method to cancel delayed `func` invocations and a `flush` method to
//    * immediately invoke them. Provide an options object to indicate whether
//    * `func` should be invoked on the leading and/or trailing edge of the `wait`
//    * timeout. The `func` is invoked with the last arguments provided to the
//    * throttled function. Subsequent calls to the throttled function return the
//    * result of the last `func` invocation.
//    *
//    * **Note:** If `leading` and `trailing` options are `true`, `func` is
//    * invoked on the trailing edge of the timeout only if the throttled function
//    * is invoked more than once during the `wait` timeout.
//    *
//    * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
//    * for details over the differences between `_.throttle` and `_.debounce`.
//    *
//    * @static
//    * @memberOf _
//    * @since 0.1.0
//    * @category Function
//    * @param {Function} func The function to throttle.
//    * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
//    * @param {Object} [options={}] The options object.
//    * @param {boolean} [options.leading=true]
//    *  Specify invoking on the leading edge of the timeout.
//    * @param {boolean} [options.trailing=true]
//    *  Specify invoking on the trailing edge of the timeout.
//    * @returns {Function} Returns the new throttled function.
//    * @example
//    *
//    * // Avoid excessively updating the position while scrolling.
//    * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
//    *
//    * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
//    * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
//    * jQuery(element).on('click', throttled);
//    *
//    * // Cancel the trailing throttled invocation.
//    * jQuery(window).on('popstate', throttled.cancel);
//    */
//   function throttle(func, wait, options) {
//       var leading = true,
//           trailing = true;

//       if (typeof func != 'function') {
//           throw new TypeError('Expected a function');
//       }
//       if (isObject(options)) {
//           leading = 'leading' in options ? !!options.leading : leading;
//           trailing = 'trailing' in options ? !!options.trailing : trailing;
//       }
//       return debounce(func, wait, {
//           'leading': leading,
//           'maxWait': wait,
//           'trailing': trailing
//       });
//   }

//   /**
//    * Checks if `value` is classified as a `Function` object.
//    *
//    * @static
//    * @memberOf _
//    * @category Lang
//    * @param {*} value The value to check.
//    * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
//    * @example
//    *
//    * _.isFunction(_);
//    * // => true
//    *
//    * _.isFunction(/abc/);
//    * // => false
//    */
//   function isFunction(value) {
//       // The use of `Object#toString` avoids issues with the `typeof` operator
//       // in Safari 8 which returns 'object' for typed array constructors, and
//       // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
//       var tag = isObject(value) ? objectToString.call(value) : '';
//       return tag == funcTag || tag == genTag;
//   }

//   /**
//    * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
//    * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
//    *
//    * @static
//    * @memberOf _
//    * @category Lang
//    * @param {*} value The value to check.
//    * @returns {boolean} Returns `true` if `value` is an object, else `false`.
//    * @example
//    *
//    * _.isObject({});
//    * // => true
//    *
//    * _.isObject([1, 2, 3]);
//    * // => true
//    *
//    * _.isObject(_.noop);
//    * // => true
//    *
//    * _.isObject(null);
//    * // => false
//    */
//   function isObject(value) {
//       var type = typeof value;
//       return !!value && (type == 'object' || type == 'function');
//   }

//   /**
//    * Converts `value` to a number.
//    *
//    * @static
//    * @memberOf _
//    * @category Lang
//    * @param {*} value The value to process.
//    * @returns {number} Returns the number.
//    * @example
//    *
//    * _.toNumber(3);
//    * // => 3
//    *
//    * _.toNumber(Number.MIN_VALUE);
//    * // => 5e-324
//    *
//    * _.toNumber(Infinity);
//    * // => Infinity
//    *
//    * _.toNumber('3');
//    * // => 3
//    */
//   function toNumber(value) {
//       if (typeof value == 'number') {
//           return value;
//       }
//       if (isSymbol(value)) {
//           return NAN;
//       }
//       if (isObject(value)) {
//           var other = isFunction(value.valueOf) ? value.valueOf() : value;
//           value = isObject(other) ? (other + '') : other;
//       }
//       if (typeof value != 'string') {
//           return value === 0 ? value : +value;
//       }
//       value = value.replace(reTrim, '');
//       var isBinary = reIsBinary.test(value);
//       return (isBinary || reIsOctal.test(value))
//         ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
//         : (reIsBadHex.test(value) ? NAN : +value);
//   }

//   function checkGlobal(value) {
//       return (value && value.Object === Object) ? value : null;
//   }

//   var _ = {};
//   _.debounce = debounce;
//   _.throttle = throttle;
//   // Expose lodash on the free variable `window` or `self` when available. This
//   // prevents errors in cases where lodash is loaded by a script tag in the presence
//   // of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch for more details.
//   (freeWindow || freeSelf || {})._ = _;

//   // Some AMD build optimizers like r.js check for condition patterns like the following:
//   if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
//       // Define as an anonymous module so, through path mapping, it can be
//       // referenced as the "underscore" module.
//       define(function () {
//           return _;
//       });
//   }
//       // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
//   else if (freeExports && freeModule) {
//       // Export for Node.js.
//       if (moduleExports) {
//           (freeModule.exports = _)._ = _;
//       }
//       // Export for CommonJS support.
//       freeExports._ = _;
//   }
//   else {
//       // Export to the global object.
//       root._ = _;
//   }
// }.call(this));